<template>
  <div class="page">
    <div style="
      margin: auto;
      width: 1200px;
      height: 109px;
          z-index: 1000">
      <div style="color: #FFFFFF; font-size: 30px;font-family: 微软雅黑; font-weight: bold ;padding-top:35px">{{
          this.systemName
        }}
      </div>
    </div>
    <div style="width:100%;background-color: #004e96; height: 65px">
      <div
        style=" font-weight: bold;width: 1200px;margin: auto"
      >
        <navigation-bar :default-active="''"/>
      </div>
    </div>
    <div style="width: 1200px;margin: auto;min-height: 500px">
      <el-row>
      </el-row>

      <div style="padding: 10px 20px;background: #fff; border: 1px solid #EBEEF5;margin-top: 10px;">
        <el-row style="margin-top: 15px" :gutter="10">
          <el-col>
            <el-col style="width: 200px;margin-bottom:6px;">
              <el-input v-model="pageQuery.keyword" placeholder="请输入标准名或标准号" clearable
                        @keyup.enter.native="querySearch"></el-input>
            </el-col>
            <el-col style="width: 200px;margin-bottom:6px;">
              <el-input v-model="pageQuery.a209" placeholder="请输入起草单位" clearable
                        @keyup.enter.native="querySearch"></el-input>
            </el-col>
            <el-col style="width: 200px;margin-bottom:6px;">
              <el-input v-model="pageQuery.projectPersonnel" placeholder="请输入起草人" clearable
                        @keyup.enter.native="querySearch"></el-input>
            </el-col>
            <el-col style="width: 200px;margin-bottom:6px;">
              <el-select v-model="pageQuery.standardType" placeholder="请选择标准类型" style="width:100%" clearable
                         @keyup.enter.native="querySearch">
                <el-option value="G" label="国家标准"/>
                <el-option value="C" label="行业标准"/>
                <el-option value="D" label="地方标准"/>
                <el-option value="T" label="团体标准"/>
                <el-option value="N" label="国际国外标准"/>
                <el-option value="J" label="工程标准"/>
                <el-option value="Z" label="技术规范"/>
              </el-select>
            </el-col>
            <el-col style="width: 200px;margin-bottom:6px;">
              <el-select v-model="pageQuery.status" placeholder="请选择标准状态" style="width:100%" clearable
                         @keyup.enter.native="querySearch">
                <el-option value="在研" label="在研"/>
                <el-option value="现行" label="现行"/>
                <el-option value="废止" label="废止"/>
                <el-option value="未生效" label="未生效"/>
              </el-select>
            </el-col>
            <el-col style="width: 400px;margin-bottom:6px;">
              <el-date-picker type="daterange" v-model="pageQuery.publishTimeRange"
                              range-separator="至"
                              start-placeholder="发布开始日期"
                              end-placeholder="发布结束日期"
                              style="width:100%"
                              value-format="yyyy-MM-dd" @keyup.enter.native="querySearch"/>
            </el-col>
            <el-col style="width: 100px;">
              <el-button style="height: 40px" type="primary" size="medium" @click="querySearch">查询</el-button>
            </el-col>
          </el-col>
        </el-row>
        <el-row style="margin-top: 15px">
          <el-col>
            <el-table v-loading="loading" :data="standardPage.list" row-key="id" border stripe fit style="width: 100%;">
              <el-table-column width="50px" label="序号" type="index"></el-table-column>
              <el-table-column label="标准号" prop="standardNo" align="left" show-overflow-tooltip>
                <template slot-scope="{row}">
                  <el-button type="text" @click="openDetail(row.id)">{{ row.standardNo }}</el-button>
                </template>
              </el-table-column>
              <el-table-column label="标准名称" prop="standardName" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.standardName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="发布单位" prop="publishUnit" align="left" width="140px" show-overflow-tooltip>
                <template slot-scope="{row}">
                  <span>{{ row.publishUnit }}</span>
                </template>
              </el-table-column>
              <el-table-column label="状态" prop="status" width="60" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.status }}</span>
                  <!--                <dict v-model="row.status" type="project_status"></dict>-->
                </template>
              </el-table-column>
              <el-table-column label="发布时间" prop="publishTime" width="100" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.publishTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="实施时间" prop="effectiveTime" width="100" align="left">
                <template slot-scope="{row}">
                  <span>{{ row.effectiveTime }}</span>
                </template>
              </el-table-column>
              <el-table-column label="起草单位" prop="a209" align="left" show-overflow-tooltip>
                <template slot-scope="{row}">
                  <span>{{ row.a209 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="起草人" prop="projectPersonnel" align="left" show-overflow-tooltip>
                <template slot-scope="{row}">
                  <span>{{ row.projectPersonnel }}</span>
                </template>
              </el-table-column>
              <!--              <el-table-column label="作废时间" prop="abolishTime" width="100" align="left">
                              <template slot-scope="{row}">
                                <span>{{ row.abolishTime }}</span>
                              </template>
                            </el-table-column>
                            <el-table-column label="页数" prop="abolishTime" width="50" align="left">
                              <template slot-scope="{row}">
                                <span v-if="row.pageNum == 0 || row.pageNum == null">{{  }}</span>
                                <span v-else>{{ row.pageNum }}</span>
                              </template>
                            </el-table-column>-->
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="{row}">
                  <el-button type="primary" :class="row.fileAddress==null?'':'right'" size="mini"
                             style="padding:7px;"
                             @click="readPDF(row.id)">预览
                  </el-button>
                  <el-button type="primary" :class="row.fileAddress==null?'':'right'" size="mini"
                             style="padding:7px;"
                             @click="downloadPDF(row.id)">下载
                  </el-button>
                </template>
              </el-table-column>

            </el-table>
            <el-pagination :total="standardPage.totalRow" :current-page.sync="standardPage.pageNumber"
                           :page-size.sync="standardPage.pageSize"
                           layout="total, prev, pager, next, jumper"
                           @current-change="querySearch"/>
          </el-col>
        </el-row>
      </div>
      <description title="标准详情" :visible="showBz100StandardDetail" width="800px"
                   @close="showBz100StandardDetail = false">
        <description-item label="标准号" v-model="standard.a100"></description-item>
        <description-item label="标准名称" v-model="standard.a298"></description-item>
        <description-item label="英文名称" v-model="standard.a302"></description-item>
        <description-item label="标准性质">
          {{ standard.nature === '0' ? '强制性' : (standard.nature === '1' ? '推荐性' : '其他') }}
        </description-item>
        <description-item label="标准状态" v-model="standard.a200"></description-item>
        <description-item label="中标分类CCS" v-model="standard.a825"></description-item>
        <description-item label="国际分类ICS" v-model="standard.a826"></description-item>
        <description-item v-model="standard.a101" label="发布日期"/>
        <description-item v-model="standard.a205" label="实施日期"/>
        <description-item v-model="standard.a206" label="废止日期"/>
        <description-item label="发布单位" v-model="standard.a102"></description-item>
        <description-item label="所属标委会" v-model="standard.a1007"></description-item>
        <description-item label="操作">
          <el-button type="primary" :class="standard.fileAddress==null?'':'right'" size="mini"
                     @click="readPDF(standard.id)">预览
          </el-button>
          <el-button type="primary" :class="standard.fileAddress==null?'':'right'" size="mini"
                     @click="downloadPDF(standard.id)">下载
          </el-button>
        </description-item>
      </description>

      <description title="标准详情" :visible="showStandardDetail" width="800px" @close="showStandardDetail = false">
        <description-item label="标准名称" v-model="standard.name"></description-item>
        <description-item label="标准号" v-model="standard.standardNumber"></description-item>
        <description-item label="英文名称" v-model="standard.englishName"></description-item>
        <description-item label="标准性质" v-model="standard.standardNature">
          <!--        <dict type="standard_nature" v-model="standard.standardNature"></dict>-->
        </description-item>
        <description-item label="标准状态" v-model="standard.standardState">
          <!--        <dict type="standard_state" v-model="standard.standardState"></dict>-->
        </description-item>
        <description-item label="被修订标准号" v-model="standard.revisedStandardNumber"></description-item>
        <description-item label="采标类型" v-model="standard.standardType"></description-item>
        <description-item label="采标号" v-model="standard.miningLabel"></description-item>
        <description-item label="采标程度" v-model="standard.standardAdoptionDegree"></description-item>
        <description-item label="采标中文名称" v-model="standard.chineseName"></description-item>
        <description-item label="中标分类CCS" v-model="standard.bidWinningClassification"></description-item>
        <description-item label="国际分类ICS" v-model="standard.internationalClassification"></description-item>
        <description-item v-model="standard.dateOfIssue" label="发布日期"/>
        <description-item v-model="standard.implementationDate" label="实施日期"/>
        <description-item v-model="standard.abolitionDate" label="废止日期"/>
        <description-item label="业务主管部门" v-model="standard.departmentChargeBusiness"></description-item>
        <description-item label="发布单位" v-model="standard.publishingUnit"></description-item>
        <description-item label="技术委员会" v-model="standard.technicalCommittee"></description-item>
        <description-item label="填报单位" v-model="standard.fillingUnit"></description-item>
        <description-item label="承担单位" v-model="standard.undertakingUnit"></description-item>
        <description-item label="项目人员" v-model="standard.projectPersonnel"></description-item>
      </description>
      <el-dialog
        title="预览"
        :visible.sync="showReadDialog"
        :before-close="closeReadDialog"
        class="pdfBox"
        fullscreen
        style="background-color: #666666;"
      >
        <el-scrollbar style=" height:100vh;background-color: #666;padding: 0px 0px!important;">
          <div class="content" style="background-color: #666666;width: 880px;margin: auto">
            <div>
              <!--              <div style="marginTop: 10px; color: #409EFF">{{ pageNum }} / {{ pageTotalNum }}</div>-->
              <!--              <pdf-->
              <!--                ref="pdf"-->
              <!--                :src="pdgUrl"-->
              <!--                :page="pageNum"-->
              <!--                @progress="loadedRatio = $event"-->
              <!--                @num-pages="pageTotalNum=$event"-->
              <!--              />-->
              <pdf v-if="showReadDialog" style="margin: 5px"
                   ref="pdf"
                   v-for="i in numPages"
                   :key="i"
                   :src="pdgUrl"
                   :page="i"
              ></pdf>
            </div>
          </div>
        </el-scrollbar>
        <!--        <div slot="footer">-->
        <!--          <el-button-group>-->
        <!--            <el-button type="primary" icon="el-icon-arrow-left" size="mini" @click="prePage">上一页</el-button>-->
        <!--            <el-button type="primary" size="mini" @click="nextPage">下一页<i class="el-icon-arrow-right el-icon&#45;&#45;right" />-->
        <!--            </el-button>-->
        <!--          </el-button-group>-->
        <!--        </div>-->
      </el-dialog>
    </div>
  </div>
</template>
<script>
import {getSystemId, getSystemName} from "../../utils/systemInfo";
import description from "../../components/Description/description";
import descriptionItem from "../../components/Description/descriptionItem";
import request from "../../utils/request";
import NavigationBar from "./compoment/navigationBar";
import pdf from "vue-pdf";

export default {
  name: 'standard',
  components: {NavigationBar, description, descriptionItem, pdf},
  data() {
    return {
      showReadDialog: false,
      pdgUrl: '',
      input: "",
      imageUrlTop: require('../../../static/image/home.jpg'),
      pageQuery: {
        pageNumber: 1,
        pageSize: 20,
        keyword: '',
        projectPersonnel: '',//起草人
        a209: '',//起草单位
        standardType: '',
        status: '',
        publishTimeRange: [],
        beginPublishTime: '',
        endPublishTime: '',
        systemId: getSystemId()
      },
      standardPage: {
        pageNumber: 1,
        pageSize: 20,
        totalPage: 0,
        totalRow: 0,
        list: []
      },
      systemName: getSystemName(),
      standard: {},
      showBz100StandardDetail: false,
      showStandardDetail: false,
      pdfLoading: false,
      numPages: 0,
      belong: getSystemId(),
      loading: true
    }
  },
  methods: {
    getNumPages() {
      let loadingTask = pdf.createLoadingTask(this.pdgUrl)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
    // localUrl0(fileName) {
    //   const _this = this
    //   request({
    //     url: '/attachmentByFileP',
    //     method: 'post',
    //     params: {
    //       name: fileName
    //     },
    //     responseType: 'blob'
    //   }).then(rsp => {
    //     this.pdfLoading = false
    //     let blob = new Blob([rsp.data], { type: 'application/octet-stream' })
    //     _this.pdgUrl = URL.createObjectURL(blob)
    //     // console.log('_this.pdgUrl', _this.pdgUrl)
    //     _this.getNumPages()
    //     _this.showReadDialog = true
    //   }).catch(e => {
    //     this.pdfLoading = false
    //     console.log(e)
    //   })
    // },
    // localUrl(fileName) {
    //   const _this = this
    //   request({
    //     url: '/attachmentByDirP',
    //     method: 'Post',
    //     params: {
    //       name: fileName,
    //       type: 'projectDocAndPdf'
    //     },
    //     responseType: 'blob'
    //   }).then(rsp => {
    //     this.pdfLoading = false
    //     let blob = new Blob([rsp.data], { type: 'application/octet-stream' })
    //     _this.pdgUrl = URL.createObjectURL(blob)
    //     // console.log('_this.pdgUrl', _this.pdgUrl)
    //     _this.getNumPages()
    //     _this.showReadDialog = true
    //   }).catch(e => {
    //     this.pdfLoading = false
    //     console.log(e)
    //   })
    // },
    localUrl0(id, fileName, types) {
      const _this = this
      request({
        url: '/knowledge/attachmentByDir',
        methods: 'get',
        responseType: 'blob',
        params: {
          belong: this.belong,
          standardId: id,
          name: fileName,
          type: 'projectDocAndPdf',
          types: types
        }
      }).then(rsp => {
        const blob = new Blob([rsp.data], {type: 'application/pdf'})
        _this.pdgUrl = URL.createObjectURL(blob)
        // console.log('_this.pdgUrl', _this.pdgUrl)
        // console.log('_this.pdgUrl', _this.pdgUrl)
        _this.getNumPages()
        this.pdfLoading = false
        _this.showReadDialog = true
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    localUrl(id, fileName, fileAddress, types) {
      const _this = this
      request({
        url: '/knowledge/attachmentByFile',
        methods: 'get',
        responseType: 'blob',
        params: {
          belong: this.belong,
          standardId: id,
          name: fileAddress,
          types: types
        }
      }).then(rsp => {
        const blob = new Blob([rsp.data], {type: 'application/pdf'})
        _this.pdgUrl = URL.createObjectURL(blob)
        // console.log('_this.pdgUrl', _this.pdgUrl)
        _this.getNumPages()
        this.pdfLoading = false
        _this.showReadDialog = true
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    // 上一页
    prePage() {
      let page = this.pageNum
      page = page > 1 ? page - 1 : this.pageTotalNum
      this.pageNum = page
    },

    // 下一页
    nextPage() {
      let page = this.pageNum
      page = page < this.pageTotalNum ? page + 1 : 1
      this.pageNum = page
    },
    closeReadDialog() {
      // URL.revokeObjectURL(this.pdgUrl)
      this.showReadDialog = false
      this.pageNum = 1
      this.pageTotalNum = 1
      this.loadedRatio = 0
      window.URL.revokeObjectURL(this.pdgUrl)
      this.pdgUrl = ''
    },
    readPDF(id) {
      const _this = this
      this.pdfLoading = true
      request({
        url: '/portalController/getStandardFileById',
        method: 'get',
        params: {
          id: id,
          belong: getSystemId()
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          _this.standard = rsp.data
          if (_this.standard != null) {
            if (!_this.standard.fileAddress) {
              let stdNo = row.a100.replace('—', '-')
              window.open('https://openstd.samr.gov.cn/bzgk/std/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=' + encodeURIComponent(stdNo), '_blank')
              return
            }
            if (!_this.standard.dowPrivileges || _this.standard.dowPrivileges == null || _this.standard.dowPrivileges == 0) {
              this.pdfLoading = false
              _this.$message.error('暂无权限')
            }
            if (_this.standard.dowPrivileges && _this.standard.dowPrivileges != null && _this.standard.dowPrivileges != 0) {
              if (_this.standard.fileAddress && _this.standard.fileAddress != null && _this.standard.fileAddress != '') {
                if (_this.standard.types != '0') {
                  _this.localUrl0(id, _this.standard.fileAddress, 1)
                } else {
                  _this.localUrl(id, _this.standard.a100 + '.pdf', _this.standard.fileAddress, 1)
                }

              } else {
                this.pdfLoading = false
                _this.$message.error('暂无文件')
              }

            }
            // this.showBz100StandardDetail = true
          } else {
            this.pdfLoading = false
            _this.$message.error('暂无权限')
            // this.showStandardDetail = true
          }
        } else {
          this.pdfLoading = false
        }
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    downloadPDF(id) {
      const _this = this
      this.pdfLoading = true
      request({
        url: '/portalController/getStandardFileById',
        method: 'get',
        params: {
          id: id,
          belong: getSystemId()
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          _this.standard = rsp.data
          if (_this.standard != null) {
            if (!_this.standard.fileAddress) {
              let stdNo = row.a100.replace('—', '-')
              window.open('https://openstd.samr.gov.cn/bzgk/std/std_list?p.p1=0&p.p90=circulation_date&p.p91=desc&p.p2=' + encodeURIComponent(stdNo), '_blank')
              return
            }
            if (!_this.standard.dowPrivileges || _this.standard.dowPrivileges == null || _this.standard.dowPrivileges == 0) {
              this.pdfLoading = false
              _this.$message.error('暂无权限')
            }
            if (_this.standard.dowPrivileges && _this.standard.dowPrivileges != null && _this.standard.dowPrivileges != 0) {
              if (_this.standard.fileAddress && _this.standard.fileAddress != null && _this.standard.fileAddress != '') {
                if (_this.standard.types != '0') {
                  _this.downloadFun(id, _this.standard.fileAddress, 0)
                } else {
                  _this.downloadFunBy1(id, _this.standard.a100 + '.pdf', _this.standard.fileAddress, 0)
                }
              } else {
                this.pdfLoading = false
                _this.$message.error('暂无文件')
              }

            }
            // this.showBz100StandardDetail = true
          } else {
            this.pdfLoading = false
            _this.$message.error('暂无权限')
            // this.showStandardDetail = true
          }
        } else {
          this.pdfLoading = false
        }
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    downloadFun(id, fileName, types) {
      let list = []
      if (fileName && fileName != '') {
        list = fileName.split(':')
      }
      request({
        url: '/knowledge/attachmentByDir',
        methods: 'get',
        responseType: 'blob',
        params: {
          belong: this.belong,
          standardId: id,
          name: fileName,
          type: 'projectDocAndPdf',
          types: types
        }
      }).then(rsp => {
        this.pdfLoading = false
        const blob = new Blob([rsp.data], {type: 'application/pdf'})
        const link = document.createElement('a')
        document.body.appendChild(link)
        link.href = window.URL.createObjectURL(blob)
        link.download = list[1]
        link.click()
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    downloadFunBy1(id, fileName, fileAddress, types) {
      request({
        url: '/knowledge/attachmentByFile',
        methods: 'get',
        responseType: 'blob',
        params: {
          belong: this.belong,
          standardId: id,
          name: fileAddress,
          types: types
        }
      }).then(rsp => {
        this.pdfLoading = false
        const blob = new Blob([rsp.data], {type: 'application/pdf'})
        const link = document.createElement('a')
        document.body.appendChild(link)
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        link.click()
      }).catch(e => {
        this.pdfLoading = false
        console.log(e)
      })
    },
    /**
     * 首页跳转
     */
    homeClick() {
      this.$router.push({path: '/home'})
    },
    /**
     * 标准体系跳转
     */
    standardClick() {
      this.$router.push({path: '/standardSystem'})
    },
    /**
     * 行业动态跳转
     */
    industryClick() {

    },
    /**
     * 点击查询
     */
    querySearch() {
      this.loading = true
      // if (!this.pageQuery.keyword) {
      //   this.$message.error('请输入检索内容！')
      //   return
      // }
      this.pageQuery.pageNumber = this.standardPage.pageNumber
      if (this.pageQuery.publishTimeRange && this.pageQuery.publishTimeRange.length === 2) {
        this.pageQuery.beginPublishTime = this.pageQuery.publishTimeRange[0]
        this.pageQuery.endPublishTime = this.pageQuery.publishTimeRange[1]
      } else {
        this.pageQuery.beginPublishTime = ''
        this.pageQuery.endPublishTime = ''
      }
      request.post('/portalController/standardPage', this.pageQuery).then(rsp => {
        if (rsp.resultCode === '0') {
          this.standardPage = rsp.data
        } else {
          this.$message({
            type: 'error',
            message: '数据加载失败'
          })
        }
        this.loading = false
      })
    },
    openDetail(id) {
      request({
        url: '/portalController/getStandard',
        method: 'get',
        params: {
          id: id
        }
      }).then(rsp => {
        if (rsp.resultCode === '0') {
          this.standard = rsp.data
          if (this.standard.a100) {
            this.showBz100StandardDetail = true
          } else {
            this.showStandardDetail = true
          }
        }
      })
    },
  },
  mounted() {
    imageUrlTop: "/static/image/home.jpg",
      document.title = this.systemName
    this.pageQuery.keyword = this.$route.query.input
    this.pageQuery.standardType = this.$route.query.system
    this.pageQuery.status = this.$route.query.status
    this.querySearch();
  }
}
</script>
<style scoped>
.page {
  background: url("../../../static/image/body-bg.jpg") no-repeat;
  height: 100%;
  width: 100%;
  background-size: 100% 775px;
}
</style>



// WEBPACK FOOTER //
// src/views/home/standard.vue